import {
  GeneralUpdate,
  PersonContact,
  PersonContactGetResponse,
  PersonGeneralGetResponse,
  RelatedPerson,
  RelatedPersonGetAllResponse,
  RelatedPersonGetResponse,
  RelatedPersonSearchParams,
} from '@quromedical/models';
import { trpc } from 'trpc';

export class NextOfKinApi {
  public async createNextOfKin(body: RelatedPerson): Promise<RelatedPersonGetResponse> {
    return await trpc.client.relatedPerson.create.mutate(body);
  }

  public async updateContactNextOfKin(
    id: string,
    body: PersonContact
  ): Promise<PersonContactGetResponse> {
    return await trpc.client.relatedPerson.updateContact.mutate({
      id,
      contact: body,
    });
  }

  public async updateGeneralNextOfKin(params: GeneralUpdate): Promise<PersonGeneralGetResponse> {
    return await trpc.client.relatedPerson.updateGeneral.mutate(params);
  }

  public async getAllNextOfKin(
    params: RelatedPersonSearchParams
  ): Promise<RelatedPersonGetAllResponse> {
    return await trpc.client.relatedPerson.getAll.query(params);
  }
}
